import React from "react"
import {Link} from "gatsby"
import {rhythm, scale} from "../utils/typography"

const BlogLayout = ({location, children}) => {
    let header, content

    if (location.pathname == '/blog') {
        header = (
            <h1
                style={{
                    ...scale(1.5),
                    marginBottom: rhythm(1.5),
                    marginTop: 0,
                }}
            >
                <Link
                    style={{
                        boxShadow: `none`,
                        color: `inherit`,
                    }}
                    to={`/blog`}
                >
                    Blog
                </Link>
            </h1>
        )
        content = children
    } else {
        header = (
            <h5
                style={{
                    fontFamily: `Montserrat, sans-serif`,
                    marginTop: 0,
                }}
            >
                <Link
                    style={{
                        boxShadow: `none`,
                        color: `inherit`,
                    }}
                    to={`/blog`}
                >
                    Back to blog
                </Link>
            </h5>
        )
        content = children
    }
    return (
        <div
            style={{
                marginLeft: `auto`,
                marginRight: `auto`,
                maxWidth: rhythm(40),
                padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
            }}
        >
            <header>{header}</header>
            <main>{content}</main>
        </div>
    )
}

export default BlogLayout